<script setup lang="ts">
import { computed } from 'vue'
import { EmbeddedChatHeader } from '#widgets/embedded-chat-header'
import { MessageEditor } from '#widgets/message-editor'
import { MessageList } from '#widgets/message-list'
import { useIsMobile } from '#shared/index'

const { hasHeader, isWritable, isWritableMobile } = defineProps<{
  hasHeader: boolean
  isWritable: boolean
  isWritableMobile: boolean
}>()

const isMobile = useIsMobile()
const isWritableCurrent = computed(() => {
  if (isMobile.value) return isWritableMobile
  return isWritable
})
</script>

<template>
  <div :class="$style.root">
    <EmbeddedChatHeader v-if="hasHeader" />
    <MessageList variant="compact" />
    <MessageEditor variant="compact" v-if="isWritableCurrent" />
  </div>
</template>

<style lang="scss" module>
.root {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
</style>
